jQuery( document ).ready(function($) {

  // tour
  $.ajax({
    url: 'https://rest.bandsintown.com/artists/boz%20scaggs/events?app_id=45PRESS_BOZ_SCAGGS',
    method: 'GET',
    dataType: 'json',
    error: () => {
      alert('Error fetching events!');
    },
    success: data => {
      const events = $('#events');
      let html = '';
      if (data.length) {
        for (let event of data) {
          let location = event.venue.city + ', ' + event.venue.region;					
          if (location === ', ') { location = ''; }
          if (event.venue.name.toLowerCase() === 'streaming live') { location = 'Online'; }
          html += '<div class="event">';

            html += '<div class="event-info">';
              html += '<div class="date font-italic font-uppercase font-bold"><span class="font-red">' + new Date(event.datetime).toLocaleDateString('en-GB', { weekday: 'short' }) + '</span>, ' + new Date(event.datetime).toLocaleDateString('en-GB', { month: 'short', day: 'numeric' }) + '</div>';
              html += '<div class="location font-italic font-uppercase font-bold">' + event.venue.location + '</div>';
            html += '</div>';

            html += '<div class="venue font-italic font-uppercase font-bold">' + event.venue.name + '</div>';

            html += '<div class="event-buttons">';
              if (event.offers[0]) {
                html += '<a href="' + event.offers[0].url + '" target="_blank" class="btn">' + event.offers[0].type + '</a>';
              }
              if (event.offers[1]) {
                html += '<a href="' + event.offers[1].url + '" target="_blank" class="btn">' + event.offers[1].type + '</a>';
              }
            html += '</div>';

					html += '</div>';					
        }
        events.html(html);
        $('#events .event:gt(4)').hide();
        $('#all-dates').on('click', function(e) {
          e.preventDefault();
          const allHidden = $('#events .event:hidden').length > 0;
          if (allHidden) {
            $('#events .event').show();
            $(this).text('view less events');
          } else {
            $('#events .event:gt(4)').hide();
            $(this).text('view all tour dates');
          }
        });
      } else {
        events.html('No upcoming events.');
      }
    }
  });

});